// extracted by mini-css-extract-plugin
export default {"container":"Ty_TI","logo":"hHoJ9","text":"kJpoJ","link":"jcmBn"};